/* eslint-disable no-console */
import React, { useState } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'

const argType = data => typeof data

const textRemark = type => {
  let textVar = ''
  if (typeof type === 'object') {
    textVar = 'n'
  }
  return textVar
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const tableWithNavbar = (titles, ...tabs) => {
  /**
   * @param {Array<string>} titles
   * @param {Array<symbol>} tabs
   * @returns {Object<function>}
   */

  /**
   * @@@ Types Validation
   */
  if (!Array.isArray(titles)) {
    console.error(
      `Type of the first argument of "tableWithNavbar" function is a${textRemark(
        titles
      )} ${argType(titles)}, is expected an array`
    )
  }

  titles.forEach((t, k) => {
    if (typeof t !== 'string') {
      console.error(
        `Type of the element number "${k +
          1}" of the first argument of "tableWithNavbar" function is a${textRemark(
          t
        )} ${argType(t)}, is expected a string`
      )
    }
  })

  tabs.forEach((t, k) => {
    if (typeof t.$$typeof !== 'symbol') {
      console.error(
        `Type of the argument number "${k +
          2}" of "tableWithNavbar" function is a${textRemark(t)} ${argType(
          t
        )}, is expected a React element`
      )
    }
  })

  /**
   * @@@ Checking The Relevance And Number Of Arguments
   */
  if (titles.length !== tabs.length) {
    console.error(
      `The number of 'Title" in the first argument of "tableWithNavbar" function does not match the number of "Table" in the next arguments`
    )
  }

  /**
   * @@@ Function Realization
   */

  const [activeTab, setActiveTab] = useState(0)
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const converedtReactElementToFunction = tabs.map((_, k) => () => tabs[k])

  const Tab = converedtReactElementToFunction[activeTab]

  return {
    Navbar: () => (
      <Nav tabs>
        {titles.map((title, inx) => (
          <NavItem key={title}>
            <NavLink
              className={activeTab === inx ? 'active' : null}
              onClick={() => toggle(inx)}
            >
              <span style={{ padding: '0 3px' }}>{title}</span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    ),
    Table: () => (
      <TabContent activeTab={activeTab}>
        <TabPane tabId={activeTab}>
          <Tab />
        </TabPane>
      </TabContent>
    ),
  }
}

export default tableWithNavbar
